import React, { useState } from "react";
import { Autoplay, EffectFade, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperClass } from "swiper/types";
import styles from "./styles.module.scss";

import { Grid, Image } from "antd";
import "swiper/css";
import "swiper/css/effect-fade";
import "./styles.scss";

const slides = [
  { id: 1, image: `${process.env.PUBLIC_URL}/images/contents/home/mv1.webp` },
  { id: 2, image: `${process.env.PUBLIC_URL}/images/contents/home/mv2.webp` },
  { id: 3, image: `${process.env.PUBLIC_URL}/images/contents/home/mv3.webp` },
  { id: 4, image: `${process.env.PUBLIC_URL}/images/contents/home/mv4.webp` },
];

const Banner: React.FC = () => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const autoplayDelay = 5000; // ms
  const fadeInOutSpeed = 1000; //ms
  const [percent, setPercent] = useState<number>(0);
  const [slideCurrentIndex, setSlideCurrentIndex] = useState(1);

  const onAutoplayTimeLeft = (
    s: SwiperClass,
    time: number,
    progress: number
  ) => {
    setPercent(
      100 - (Math.round(Math.max(0, Math.min(100, progress * 100))) % 100)
    );
  };

  const handleRealIndexChange = (swiper: SwiperClass) => {
    setSlideCurrentIndex(swiper.realIndex + 1);
  };
  const getBannerHeight = () => {
    if (screens.xl) return "var(--banner-height-xl)";
    if (screens.lg) return "var(--banner-height-lg)";
    if (screens.md) return "var(--banner-height-md)";
    if (screens.sm) return "var(--banner-height-sm)";
    return "var(--banner-height-xs)"; // Default for xs or smaller
  };

  return (
    <div className={`${styles.bannerContainer} banner-container`}>
      <Swiper
        pagination={{ dynamicBullets: true, clickable: true }}
        modules={[EffectFade, Autoplay, Pagination]}
        loop
        autoplay={{ delay: autoplayDelay, disableOnInteraction: false }}
        effect="fade"
        speed={fadeInOutSpeed}
        // onAutoplayTimeLeft={onAutoplayTimeLeft}
        // onRealIndexChange={handleRealIndexChange}
      >
        {slides.map((_slide, el) => {
          return (
            <SwiperSlide key={_slide.id}>
              {/* <div
                className={styles.bannerWrapper}
                style={{ height: getBannerHeight() }}
              > */}
              <Image
                className={styles.bannerImage}
                style={{ height: getBannerHeight() }}
                preview={false}
                src={_slide.image}
              />
              {/* </div> */}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default Banner;
